export default "__VITE_ASSET__CqcvGeNi__"